import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetdashboardpage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetDashboardPage } = await import(
        /* webpackChunkName: "BudgetDashboardPage" */ '../../../components/pages/private/BudgetDashboardPage'
      )
      return {
        default: BudgetDashboardPage,
      }
    })}
    exact
    key={paths.budgetDashboard}
    path={paths.budgetDashboard}
  />,
]
